import { LoadingPage } from "@/components/elements/Loading/Loading";
import { Tab } from "@/components/elements/Tab";
import { TopPage } from "@/components/elements/TopPage";
import { useInitSetup } from "@/providers/InitSetupProvider";
import { AppRoutes } from "@/routes/config";
import { background, divider } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { getDynamicRoute } from "@/utils/url";
import { Box } from "@mui/material";
import { FC, useMemo } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

type TCompanyLayoutProps = {};

export const CompanyLayout: FC<TCompanyLayoutProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading: isInitLoading } = useInitSetup();

  const { id } = useParams();

  const activeTab = useMemo(() => {
    if (location.pathname === AppRoutes.company || location.pathname === AppRoutes.companyEdit) return AppRoutes.company;
    if (
      location.pathname === AppRoutes.companyBranch ||
      location.pathname === AppRoutes.companyBranchCreate ||
      location.pathname === getDynamicRoute(AppRoutes.companyBranchEdit, { id })
    )
      return AppRoutes.companyBranch;
    if (
      location.pathname === AppRoutes.companyBranch ||
      location.pathname === AppRoutes.companyBranchCreate ||
      location.pathname === getDynamicRoute(AppRoutes.companyBranchEdit, { id })
    )
      return AppRoutes.companyBranch;
    if (location.pathname === AppRoutes.companyAccount || location.pathname === AppRoutes.companyAccountEdit) return AppRoutes.companyAccount;
    else return location.pathname;
  }, [location]);

  const backUrl = useMemo(() => {
    if (location.pathname === AppRoutes.companyBranchCreate || location.pathname === getDynamicRoute(AppRoutes.companyBranchEdit, { id })) {
      return AppRoutes.companyBranch;
    } else {
      return AppRoutes.home;
    }
  }, [location]);

  if (isInitLoading) return <LoadingPage />;

  return (
    <Box>
      <TopPage title="会社情報" backUrl={backUrl} />
      <Tab
        value={activeTab}
        onChange={(_, tab) => navigate(tab.toString())}
        options={[
          { label: "基本情報", value: AppRoutes.company },
          { label: "事業所管理", value: AppRoutes.companyBranch },
          { label: "オンライン申請のアカウント管理", value: AppRoutes.companyAccount },
        ]}
      >
        <Box
          border={`1px solid ${divider.middle}`}
          bgcolor={background.white}
          sx={{ borderBottomLeftRadius: rounded.sm, borderBottomRightRadius: rounded.sm }}
        >
          <Outlet />
        </Box>
      </Tab>
    </Box>
  );
};
